import { render } from "./ResourcesGIC.vue?vue&type=template&id=dfdfbcd0"
import script from "./ResourcesGIC.vue?vue&type=script&lang=js"
export * from "./ResourcesGIC.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__